<script lang="ts">
import { defineComponent, h } from 'vue';

import { makeTagProps, useRender } from '../../composable';

export const componentName = 'CdsCardTitle';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps()
  },
  setup(props, { slots }) {
    useRender(() =>
      h(
        props.tag,
        {
          class: 'cds-card-title'
        },
        slots.default?.()
      )
    );

    return {};
  }
});
</script>
